export default "__VITE_PUBLIC_ASSET__365401d7__"